import SubCategoryForm from "./SubCategoryForm";
import "./styles.scss";

export default { SubCategoryForm };
